<template>
  <div>
    <p class="title">
      <slot name="title"></slot>
    </p>
    <p class="subtitle">
      <slot name="subtitle"></slot>
    </p>
    <p class="desc">
      <slot name="desc"></slot>
    </p>
    <div v-if="!showSuccessInfo">
      <div class="form-box">
        <!-- newPassword input -->
        <div class="login-formitem-group">
          <div class="form-item-label">
            <label for="newPassword">{{ $i18n.t('formPassword') }}*</label>
          </div>
          <div class="new-password-input">
            <input
              class="form-item-input fs-mask"
              :class="{ 'input-border-err': validateErr }"
              :type="newPswInputType"
              id="newPassword"
              autocomplete="new-password"
              role="input new password"
              v-model.trim="newPassword"
              @input="handleNewPswChange"
            />
            <img
              v-show="showNewPsw"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="() => changeNewPswType('password')"
              alt="hide new password"
            />
            <img
              v-show="!showNewPsw"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="() => changeNewPswType('text')"
              alt="show new password"
            />
          </div>
        </div>
        <div class="new-password-rules">
          <div class="desc-item" v-for="(item, index) in pswRules" :key="index">
            <img v-if="item.matched" src="~img/check-green.png" alt="psw-img" />
            <img v-if="!item.matched" src="~img/check-gray.png" alt="psw-img" />
            <p
              :class="{
                'psw-right': item.matched,
                'psw-error': !item.matched,
              }"
            >
              {{ $i18n.t(item.desc) }}
            </p>
          </div>
        </div>
        <!-- confirmPassword input -->
        <div class="login-formitem-group">
          <div class="form-item-label">
            <label for="confirmPassword">{{ $i18n.t('formConfirmPassword') }}*</label>
          </div>
          <div class="confirm-password-input">
            <input
              class="form-item-input fs-mask"
              :class="{ 'input-border-err': errMsg }"
              :type="confirmPswInputType"
              id="confirmPassword"
              autocomplete="new-password"
              role="input confirm password"
              v-model="confirmPassword"
              @input="handleConfirmPswChange"
            />
            <img
              v-show="showConfirmPsw"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="() => changeConfirmPswType('password')"
              alt="hide confirm password"
            />
            <img
              v-show="!showConfirmPsw"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="() => changeConfirmPswType('text')"
              alt="show confirm password"
            />
          </div>
        </div>
        <!-- 错误提示 -->
        <p v-if="errMsg" class="error-message">{{ errMsg }}</p>
        <p v-if="notMatch" class="error-message">{{ $i18n.t('forgetpsw-notmatch') }}</p>
      </div>
      <div class="button">
        <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
          <div v-if="!loading" @click="handleSave" role="button">
            {{ $i18n.t('forgetpsw-save') }}
          </div>
          <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
        </div>
      </div>
    </div>
    <div v-if="showSuccessInfo">
      <div class="success-info">
        <img src="@/components/LeftAccount/images/icon-verifyed.svg" alt="success" />
        <p>{{ $i18n.t('forgetpsw-saved') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  const pswRules = [
    {
      matched: false,
      regExp: /^.{8,}/,
      desc: 'forgetpsw-rule1',
    },
    {
      matched: false,
      regExp: /[a-záàâäæçéèêëíîïñóôœúùûüö]/,
      desc: 'forgetpsw-rule2',
    },
    {
      matched: false,
      regExp: /[A-ZÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ]/,
      desc: 'forgetpsw-rule3',
    },
    {
      matched: false,
      regExp: /\d/,
      desc: 'forgetpsw-rule4',
    },
    /* eslint-disable */
    {
      matched: false,
      /* regExp: {
        test: str => {
          const reg1 = /[!#$%&*,.:;?@\[\]^_{|}+=¡¿~]/;
          // const reg2 = /[\<\>\/'"\-\\\(\)]/;
          const reg2 = /[^a-záàâäæçéèêëíîïñóôœúùûüöA-ZÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ\d!#$%&*,.:;?@\[\]^_{|}+=¡¿~]/g;
          return reg1.test(str) && !reg2.test(str);
        },
      }, */
      regExp: /[!#$%&*,.:;?@\[\]^_{|}+=¡¿~\<\>\/'"\-\\\(\)«»¢£¤¥§©¬®¯°±²³´`µ¶·¸¹º¼½¾×÷]/,
      desc: 'forgetpsw-rule5',
    },
  ];
  export default {
    name: 'ForceResetPsw',
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      errMsg: {
        type: String,
        default: '',
      },
    },
    beforeUnmount() {
      this.showSuccessInfo = false;
    },
    data() {
      return {
        validateErr: false,
        loginDisable: true,
        newPswInputType: 'password',
        confirmPswInputType: 'password',
        newPassword: '',
        confirmPassword: '',
        pswRules,
        notMatch: false,
        showSuccessInfo: false,
      };
    },
    computed: {
      showNewPsw() {
        return this.newPswInputType === 'text';
      },
      showConfirmPsw() {
        return this.confirmPswInputType === 'text';
      },
    },
    methods: {
      showSuccess(cb) {
        this.showSuccessInfo = true;
        setTimeout(() => {
          cb && cb();
        }, 2000);
      },
      changeNewPswType(value) {
        this.newPswInputType = value;
      },
      changeConfirmPswType(value) {
        this.confirmPswInputType = value;
      },
      handleNewPswChange(e) {
        this.$emit('update:errMsg', '');
        this.notMatch = false;
        const { value } = e.target;
        // 校验
        let flag = false;
        this.pswRules.forEach(item => {
          if (item.regExp.test(value)) {
            item.matched = true;
          } else {
            item.matched = false;
            flag = true;
          }
        });
        this.loginDisable = flag;
        this.validateErr = flag;
      },
      handleConfirmPswChange(e) {
        this.notMatch = false;
      },
      handleSave() {
        if (this.loginDisable) return;
        if (this.newPassword === this.confirmPassword) {
          const payload = {
            newPassword: this.newPassword,
            confirmPassword: this.confirmPassword,
          };
          this.$emit('handleSave', payload);
        } else {
          this.notMatch = true;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use '@/assets/css/variables.scss' as *;
  .title {
    width: 450px;
    margin: 0 auto;
    @include font(32px, 700);
    line-height: 44px;
    margin-bottom: 30px;
    text-align: center;
  }

  .subtitle {
    width: 450px;
    margin: 0 auto;
    @include font(18px, 700);
    /* prettier-ignore */
    font-size: min(14Px);
    margin-bottom: 5px;
    text-align: center;
  }

  .desc {
    width: 450px;
    margin: 0 auto;
    @include font(18px, 400);
    /* prettier-ignore */
    font-size: min(14Px);
    margin-bottom: 5px;
    text-align: center;
  }

  .button {
    width: 450px;
    margin: 30px auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .form-box {
    width: 450px;
    margin: 30px auto;
    .form-item-label {
      @include font(18px, 600);
      /* prettier-ignore */
      font-size: min(14Px);
      line-height: 22px;
      margin-bottom: 16px;
      white-space: nowrap;
    }
    .form-item-input {
      box-sizing: border-box;
      width: 100%;
      height: 58px;
      padding: 12px 12px;
      line-height: 34px;
      border: 2px solid #bec7cc;
      border-radius: 10px;
      color: #163049;
      @include font(18px, 400);
      /* prettier-ignore */
      font-size: min(14Px);
      @include beauty-placeholder(24px, #cad1d6);

      &.input-border-err {
        border-color: $color-red;
      }

      &:-webkit-autofill {
        line-height: 34px;

        @include font(24px, 400);
      }

      &:-internal-autofill-selected {
        color: #163049 !important;
        @include font(18px, 400);
        /* prettier-ignore */
        font-size: min(14Px);
      }
    }

    .login-formitem-group {
      position: relative;

      .eye {
        position: absolute;
        top: 50%;
        right: 20px;
        width: 34px;
        height: 34px;
        transform: translateY(-50%);
      }
    }

    .new-password-input {
      position: relative;
      margin-bottom: 16px;
    }

    .confirm-password-input {
      position: relative;
    }

    .new-password-rules {
      @include font(16px, 600);
      /* prettier-ignore */
      font-size: min(14Px);
      margin-bottom: 20px;

      .desc-item {
        @include flex(row, center, flex-start);
        margin-bottom: 10px;

        img {
          margin-right: 10px;
        }
        p {
          @include font(16px, 600);
          /* prettier-ignore */
          font-size: min(14Px);
        }
        .psw-error {
          color: #7f898f !important;
        }
        .psw-right {
          color: #378523 !important;
        }
      }
    }
  }

  .login-btn {
    @include font(24px, 600);
    /* prettier-ignore */
    font-size: min(14Px);
    cursor: pointer;
    display: inline-block;
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #fff;
    text-align: center;
    background: $color-glod-radient;
    border-radius: 10px;

    &-disable {
      cursor: not-allowed;
      background: #9eacb5;
    }
  }

  .error-message {
    @include font(20px, 400);
    /* prettier-ignore */
    font-size: min(14Px);

    width: 450px;
    text-align: start;
    margin: 0 auto;
    margin-top: 16px;
    line-height: 27px;
    color: #c22;
    word-wrap: break-word;
    //word-break: break-all;
  }

  .success-info {
    margin: 40px 0px;
    text-align: center;
    @include font(34px, 600);

    img {
      width: 120px;
      height: 120px;
      margin-bottom: 30px;
    }

    p {
      color: #378523;
    }
  }

  @media screen and (max-width: 1024px) {
    .form-box {
      width: 100%;
      margin: 15px auto;

      .error-message {
        @include font(14px, 400);
        width: 100%;
      }
    }
    .button {
      width: 100%;
    }
  }
</style>
